import { Injectable } from '@angular/core';
import { ISelectItem } from 'mt-ui-lib/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly userThemeKey = 'mt-auth-theme';
  private readonly _theme$ = new BehaviorSubject<string>(null);
  public get theme$(): Observable<string> {
    return this._theme$.asObservable();
  }
  public readonly themes: ISelectItem[] = [
    { key: 'light', value: 'Светлая тема' },
    { key: 'dark', value: 'Темная тема' },
  ];

  public init(): void {
    this.setDarkTheme();
  }

  setTheme(theme: string) {
    this._theme$.next(theme);
    localStorage.setItem(this.userThemeKey, theme);
    document.documentElement.className = theme;
  }

  public setUserTheme(): void {
    const theme = localStorage.getItem(this.userThemeKey) ?? 'light';
    this.setTheme(theme);
  }

  public setDarkTheme() {
    document.documentElement.className = 'dark';
  }
}
